/**
 * returns the current character count in input value
 * @param event
 * @return number
 */
export function getCharCount(event) {
  if (event && event.target && event.target.maxLength && event.target.value.length > 0) {
    return event.target.value.length;
  }
  return 0;
}
